/**
 * HEIRLOOM — main entry point.
 * Two-player co-op garden game built for mobile.
 * By Jake & Claude.
 */
import Phaser from 'phaser';
import { BootScene } from './scenes/BootScene.js';
import { TitleScene } from './scenes/TitleScene.js';
import { GardenScene } from './scenes/GardenScene.js';
import { MemoryScene } from './scenes/MemoryScene.js';
import { MailboxScene } from './scenes/MailboxScene.js';

// Mobile-first: canvas fills the viewport at actual device resolution.
// Scenes must read this.scale.width/height (not hardcoded constants).
const config = {
  type: Phaser.AUTO,
  parent: 'game-container',
  backgroundColor: '#0a0612',
  scale: {
    mode: Phaser.Scale.RESIZE,
    autoCenter: Phaser.Scale.NO_CENTER,
    width: window.innerWidth,
    height: window.innerHeight,
  },
  input: {
    activePointers: 3,
  },
  scene: [BootScene, TitleScene, GardenScene, MemoryScene, MailboxScene],
  render: {
    antialias: true,
    pixelArt: false,
    roundPixels: false,
    preserveDrawingBuffer: true,
  },
};

const game = new Phaser.Game(config);

// Hide boot splash once Phaser starts
game.events.once('ready', () => {
  const splash = document.getElementById('boot-splash');
  if (splash) {
    splash.classList.add('gone');
    setTimeout(() => splash.remove(), 1000);
  }
});

// Mobile detection helper
window.HEIRLOOM = {
  game,
  isMobile: /Android|iPhone|iPad|iPod/i.test(navigator.userAgent) || ('ontouchstart' in window && window.innerWidth < 1024),
};
